import { Action } from "../../index";
import { combineReducers } from "redux";
import { Dispatch } from "react-redux";
import API from "../../../vendor/api";
API.transportMethod = "WS";

import { clone } from "lodash";
import { normalize, Schema, arrayOf } from "normalizr";

import {  } from "../../../types/index";

/**
 * Actions
 */
export const ADD_CONTACT_ENTITY= "meumedico/contacts/ADD_CONTACT_ENTITY";
export function addContactEntity(userId: string) {
    return {
        type: ADD_CONTACT_ENTITY,
        payload: {
            userId
        }
    }
}

export const ADD_CONTACT_ENTITIES = "meumedico/contacts/ADD_CONTACT_ENTITIES";
export function addContactEntities(userIds: string[]) {
    return {
        type: ADD_CONTACT_ENTITIES,
        payload: {
            userIds
        }
    }
}

// Reducer
export interface ContactState {
    allIds: string[];
}

const INITIAL_STATE: ContactState = {
    allIds: []
}

export interface ContactEntityPayload {
    userId: string;
}

export interface ContactEntitiesPayload {
    userIds: string[];
}

function allContacts(state: any = [], action: Action<ContactEntityPayload & ContactEntitiesPayload>) {
    switch(action.type) {
        case ADD_CONTACT_ENTITY:
            return state.concat([action.payload.userId]);
        case ADD_CONTACT_ENTITIES:
            return state.concat(action.payload.userIds);
        default:
            return state;
    }
}

const contactsReducer = combineReducers({
    allIds : allContacts
});

export default contactsReducer;


// WEBPACK FOOTER //
// ./src/redux/modules/contacts/contacts.tsx